export default "/images/97441b708b210b69c73a2ddac73c5e19.png";